module.exports = __webpack_public_path__ + "img/Aura_music.c9ce34d3.png";